import { useCarListSort } from "@apac/cars";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { AvailabilityListSort } from "@tenant/ui";

export const CarListSort = ({ className }: PlatformComponentProps) => {
  const {
    context: { sortOptions, selectedSort },
    handlers: { getSortLabelKey, handleSortChange },
  } = useCarListSort();

  return (
    <AvailabilityListSort
      className={className}
      sortOptions={sortOptions}
      selectedSort={selectedSort}
      handleSortChange={handleSortChange}
      getSortLabelKey={getSortLabelKey}
    />
  );
};
